"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unloadSentry = exports.setUpSentry = exports.getDefaultOptions = exports.getVtbTunnel = exports.normalizeEnvironment = exports.getEnvFromLocation = void 0;
var Sentry = __importStar(require("@sentry/browser"));
var browser_1 = require("@sentry/browser");
var utils_1 = require("@sentry/utils");
var default_options_1 = require("./default-options");
function getEnvFromLocation() {
    var hostEnvName = window.location.host.split(".")[0];
    switch (hostEnvName) {
        case "m2":
            return "prod";
        case "dev":
        case "dev-m2":
            return "dev";
        case "test-m2":
        case "test":
            return "test";
        case "stage-m2":
            return "stage";
        default:
            return "feature";
    }
}
exports.getEnvFromLocation = getEnvFromLocation;
var environments = {
    prod: "prod",
    production: "prod",
    develop: "dev",
    dev: "dev",
    development: "dev",
    test: "test",
    testing: "test",
    stage: "stage",
    staging: "stage",
    feature: "feature",
};
function normalizeEnvironment(environment) {
    if (!environment) {
        console.info("There is no environment, so return the default one - 'dev'.");
        return "dev";
    }
    return environments[environment.toLowerCase()] || "feature";
}
exports.normalizeEnvironment = normalizeEnvironment;
function getVtbTunnel(dsn, tunnel) {
    if (tunnel) {
        return tunnel;
    }
    if (!dsn || typeof window === "undefined") {
        return;
    }
    var href = window.location.href;
    if (href.includes("rb.m2") || href.includes("m2.region.vtb")) {
        var pathname = new URL(dsn).pathname;
        return "/_sentry" + pathname;
    }
    return;
}
exports.getVtbTunnel = getVtbTunnel;
function getDefaultOptions(opts) {
    return __assign(__assign(__assign({}, default_options_1.defaultOptions), opts), { environment: normalizeEnvironment(opts.environment), tunnel: getVtbTunnel(opts.dsn, opts.tunnel) });
}
exports.getDefaultOptions = getDefaultOptions;
function hasSentry() {
    if (!(Sentry === null || Sentry === void 0 ? void 0 : Sentry.defaultIntegrations)) {
        console.warn("There is no Sentry, so Sentry wasn't set up.");
        return false;
    }
    return true;
}
function setUpSentry(options) {
    var _a, _b, _c, _d, _e;
    if (!hasSentry())
        return;
    var hub = Sentry.getCurrentHub();
    var defaultIntegrations = ((_c = (_b = (_a = hub.getStack()[0]) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.getOptions()) === null || _c === void 0 ? void 0 : _c.integrations) ||
        Sentry.defaultIntegrations;
    var environment = ((_e = (_d = hub.getClient()) === null || _d === void 0 ? void 0 : _d.getOptions()) === null || _e === void 0 ? void 0 : _e.environment) ||
        getEnvFromLocation() ||
        options.environment;
    var client = new Sentry.BrowserClient(__assign(__assign({ integrations: defaultIntegrations }, options), { environment: normalizeEnvironment(environment), transport: utils_1.supportsFetch()
            ? Sentry.makeFetchTransport
            : Sentry.makeXHRTransport, stackParser: utils_1.stackParserFromStackParserOptions(Sentry.defaultStackParser) }));
    client.setupIntegrations();
    var stack = hub.getStack();
    stack.push({ client: client, scope: browser_1.Scope.clone(hub.getScope()) });
}
exports.setUpSentry = setUpSentry;
function unloadSentry() {
    if (!hasSentry())
        return;
    var hub = Sentry.getCurrentHub();
    var stack = hub.getStack();
    stack.pop();
}
exports.unloadSentry = unloadSentry;
//# sourceMappingURL=index.js.map